import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import './style.scss';
import Button from '../../ui/Button';
import ButtonsGroup from '../../ui/ButtonsGroup';
import { useTranslation } from 'react-i18next';
const AdminPreviewGameplayControls = ({ showTaskResult, setShowTaskResult, currentTaskInfo, currentInputTaskAnswer, currentSelectionTaskAnswers, setCurrentSelectionTaskAnswers, currentPhotoUploadTaskAnswer, validateInputField, validateSelect, goToNextTask, currentTaskStatus, setCurrentTaskStatus, onTryAgainButtonClick, previewType, isLastTask, currentValidatedInputTaskAttempt, setCurrentInputTaskAnswer, }) => {
    const { i18n, t } = useTranslation();
    const checkIfTaskAnswerIsCorrect = (selectedAnswers, answers) => {
        const correctAnswerIds = answers
            .filter((answer) => answer.isCorrect)
            .map((answer) => answer.uid)
            .sort((a, b) => a - b);
        const selectedAnswersIds = selectedAnswers.map((answer) => answer.uid).sort((a, b) => a - b);
        return (correctAnswerIds.length === selectedAnswersIds.length &&
            correctAnswerIds.every((uid, index) => uid === selectedAnswersIds[index]));
    };
    const onTaskSkipButtonClick = async () => {
        goToNextTask();
    };
    const onTaskNextButtonClick = async () => {
        if (showTaskResult) {
            setShowTaskResult(false);
            goToNextTask();
        }
        else {
            switch (currentTaskInfo?.taskType) {
                case 'information':
                    goToNextTask();
                    break;
                case 'action':
                    switch (currentTaskInfo.answerType) {
                        case 'text':
                        case 'validated-text':
                            const inputTaskValidationErrors = validateInputField({
                                fieldName: 'inputTaskAnswer',
                                value: currentInputTaskAnswer,
                            });
                            if (!inputTaskValidationErrors) {
                                if (currentTaskInfo.answerType === 'validated-text') {
                                    const correctAnswers = currentTaskInfo.answers.map((answer) => answer.content[i18n.language]);
                                    const isTaskAnswerCorrect = correctAnswers.some((answer) => answer.toLowerCase().trim() === currentInputTaskAnswer.toLowerCase().trim());
                                    setCurrentTaskStatus(isTaskAnswerCorrect
                                        ? 'completed'
                                        : currentValidatedInputTaskAttempt < 3
                                            ? 'failed_attempt'
                                            : 'failed');
                                    setCurrentInputTaskAnswer('');
                                }
                                else {
                                    setCurrentTaskStatus('completed');
                                }
                                setShowTaskResult(true);
                            }
                            break;
                        case 'single-selection':
                        case 'multiple-selection':
                        case 'player-selection':
                            const selectedAnswers = currentSelectionTaskAnswers?.filter((answer) => answer.isSelected);
                            const selectionTaskValidationErrors = validateSelect('selectionTaskAnswer', !!selectedAnswers?.length);
                            if (!selectionTaskValidationErrors) {
                                if (currentTaskInfo.answerType === 'player-selection') {
                                    setCurrentTaskStatus('completed');
                                }
                                else {
                                    const isAnswerCorrect = checkIfTaskAnswerIsCorrect(selectedAnswers, currentTaskInfo.answers);
                                    setCurrentTaskStatus(isAnswerCorrect ? 'completed' : 'failed');
                                    setCurrentSelectionTaskAnswers(currentSelectionTaskAnswers.map((answer) => ({
                                        ...answer,
                                        isSelected: false,
                                    })));
                                }
                                setShowTaskResult(true);
                            }
                            break;
                        case 'upload':
                            const photoUploadTaskValidationErrors = validateSelect('photoUploadTaskAnswer', !!currentPhotoUploadTaskAnswer);
                            if (!photoUploadTaskValidationErrors) {
                                setCurrentTaskStatus('completed');
                                setShowTaskResult(true);
                            }
                            break;
                    }
                    break;
            }
        }
    };
    return (_jsx(ButtonsGroup, { justify: 'end', children: showTaskResult ? (_jsxs(_Fragment, { children: [currentTaskInfo.taskType === 'action' &&
                    (currentTaskInfo?.answerType === 'single-selection' ||
                        currentTaskInfo?.answerType === 'multiple-selection') &&
                    currentTaskStatus === 'failed' && (_jsx(Button, { onClick: onTryAgainButtonClick, label: t('button.try_again'), variant: 'outlined' })), currentTaskInfo.taskType === 'action' &&
                    currentTaskInfo?.answerType === 'validated-text' &&
                    currentTaskStatus === 'failed_attempt' && (_jsx(Button, { onClick: onTryAgainButtonClick, label: t('button.try_again'), variant: 'outlined' })), previewType === 'rally' ? (isLastTask ? null : (_jsx(Button, { label: t('button.next'), onClick: onTaskNextButtonClick }))) : null] })) : (_jsxs(_Fragment, { children: [previewType === 'rally' &&
                    currentTaskInfo?.taskType !== 'information' &&
                    !isLastTask && (_jsx(Button, { label: t('button.skip'), variant: 'outlined', onClick: onTaskSkipButtonClick })), previewType === 'single-task' ? (currentTaskInfo?.taskType !== 'check-in' &&
                    currentTaskInfo?.taskType !== 'information' ? (_jsx(Button, { label: t('button.next'), onClick: onTaskNextButtonClick })) : null) : (_jsxs(_Fragment, { children: [currentTaskInfo?.taskType !== 'check-in' &&
                            currentTaskInfo?.taskType !== 'information' && (_jsx(Button, { label: t('button.next'), onClick: onTaskNextButtonClick })), currentTaskInfo?.taskType === 'information' ? (!isLastTask ? (_jsx(Button, { label: t('button.next'), onClick: onTaskNextButtonClick })) : null) : null] }))] })) }));
};
export default AdminPreviewGameplayControls;
